import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Store } from '@sama/app-state';
import { Observable } from 'rxjs';
import { ShapeState } from '../../../../../../../../cross-team-shared/annotation/shared/state/shape-state';
import { isShapeVisible$ } from '../../../../../../../../cross-team-shared/annotation/shared/utils/keyframe-utils';
import { EventTrackingValueWithSource } from '../../../../../../../../cross-team-shared/misc-utils';
import { AbstractAnnotationStore } from '../../../../../../../../outputs/annotation/annotation-shared/state/root/abstract-annotation-store';
import { VisibilityState } from '../../../../../../../../team-apis/otterdam/answers/shape-typings';
import { TaskWorkspaceStore } from '../../../../../../../h3ml/state/task-workspace-store';
import { RootKeyboardShortcutService } from '../../../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';
import { ShapeVisibilityService } from '../../../../../../../shared/misc-services/shape-visibility.service';

@Component({
  selector: 'h3-toggle-shape-visibility-button',
  templateUrl: './toggle-shape-visibility-button.component.html',
  styleUrls: ['./toggle-shape-visibility-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
/** @deprecated used for old projects without objects */
export class ToggleShapeVisibilityButtonComponent implements OnInit {
  @Input({ required: true }) shapeStore!: Store<ShapeState>;

  private readonly taskWorkspaceStore = inject(TaskWorkspaceStore);

  visibility$!: Observable<VisibilityState>;
  readOnly?: boolean;
  tooltip: string;

  constructor(
    private keyboardShortcutService: RootKeyboardShortcutService,
    private shapeVisibilityService: ShapeVisibilityService,
    private store: AbstractAnnotationStore,
  ) {
    this.tooltip =
      'Change shape visibility' +
      this.keyboardShortcutService.tooltipSuffix('changeShapeVisibility');
  }

  ngOnInit() {
    this.visibility$ = isShapeVisible$(
      this.store('frameNumber'),
      this.shapeStore,
    );
    this.readOnly = this.taskWorkspaceStore.state().readOnly;
  }

  changeShapeVisibility(
    eventTrackingValue: EventTrackingValueWithSource,
    event: MouseEvent,
  ) {
    this.shapeVisibilityService.changeShapeVisibility(eventTrackingValue, [
      this.shapeStore.state().index,
    ]);
    event.stopPropagation();
  }
}
